import { z } from 'zod';
import { serialConnectionConfigSchema } from './serial.connection-config.zod';
import { tcpClientConnectionConfigSchema } from './tcp-client.connection-config.zod';
import { tcpServerConnectionConfigSchema } from './tcp-server.connection-config.zod';
import { udpSocketConnectionConfigSchema } from './udp-socket.connection-config.zod';
import { mqttBrokerConnectionConfigSchema } from './mqtt-broker.connection-config.zod';
import { ptl110PickLightConnectionConfigSchema } from './ptl110-pick-light.connection-config.zod';
import { ioLinkMasterConnectionConfigSchema } from './io-link-master.connection-config.zod';

export const connectionConfigDetailsSchema = z.discriminatedUnion('kind', [
    serialConnectionConfigSchema,
    tcpClientConnectionConfigSchema,
    tcpServerConnectionConfigSchema,
    udpSocketConnectionConfigSchema,
    mqttBrokerConnectionConfigSchema,
    ioLinkMasterConnectionConfigSchema,
    ptl110PickLightConnectionConfigSchema,
]);

export type ConnectionConfigDetails = z.infer<typeof connectionConfigDetailsSchema>;
export type ConnectionConfig = ConnectionConfigDetails['details'];

export const connectionEntitySchema = z.object({
    id: z.string(),
    name: z.string(),
    connectionConfig: z.object({
        id: z.string(),
        config: connectionConfigDetailsSchema,
    }),
});

export interface ConnectionEntity extends z.infer<typeof connectionEntitySchema> {}
